import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "attrs"];
import React from 'react';
import classnames from 'classnames';
const Description = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    attrs
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const {
    value
  } = attrs;
  const cls = classnames({
    'components-description-render': true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), value);
});
export default Description;